import Col from 'react-bootstrap/lib/Col'
import Grid from '../../../../components/grid'
import PropTypes from 'prop-types'
import React from 'react'
import Row from 'react-bootstrap/lib/Row'
import llLogo from '../../../../images/LL_Approved_Shops.svg'
import llSportsLogosSB from '../../../../images/Softball.svg'
import llSportsLogosBB from '../../../../images/Baseball.svg'
import llSportsLogosCH from '../../../../images/Challenger.svg'
import {css} from 'glamor'
import {colors, media, text} from '../../../../styles'
import {storeCodes, storeTypes} from '../../../../constants/storeNavigation'

export const isLittleLeagueStore = (store) =>
  store.StoreCode === storeCodes[storeTypes.LITTLE_LEAGUE]

const style = {
  banner: css(
    {
      backgroundColor: colors.littleLeagueBlue,
      padding: '10px',
      '& a': {
        color: colors.white,
        textDecoration: 'underline'
      }
    },
    text.bodyLarge
  ),
  notice: css({
    color: colors.gray46,
    textAlign: 'center',
    margin: '60px 0 0',
    '& img:first-child': {
      marginRight: '20px',
      maxWidth: '120px'
    }
  }),
  promo: css(
    {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: colors.littleLeagueBlue,
      color: colors.white,
      padding: '10px 20px',
      marginTop: '4px',
      overflow: 'hidden',
      '& > div': {
        flexGrow: 1
      },
      '& > img': {
        flex: 'none',
        maxWidth: '50px',
        margin: '8px'
      },
      ...media.mobile({
        margin: '4px -15px 0'
      }),
      ...media.desktop({
        '& span': {
          fontWeight: 'bold',
          fontSize: 'x-large',
          verticalAlign: 'middle',
          paddingRight: '5px'
        }
      })
    },
    text.bodyLarge
  )
}

export const LittleLeagueAdminBanner = ({store}) => (
  <div {...style.banner}>
    <Grid>
      <Row>
        <Col xs={12}>
          <a href={`/store/claimstore?storeid=${store.StoreID}`} rel="nofollow">
            League Admin? Start fundraising
          </a>
        </Col>
      </Row>
    </Grid>
  </div>
)

LittleLeagueAdminBanner.propTypes = {
  store: PropTypes.object.isRequired
}

export const LittleLeaguePromo = () => (
  <Row>
    <Col xs={12}>
      <div {...style.promo}>
        <div>
          <span>15%</span> of all sales are donated to your league.
        </div>
        <img src={llSportsLogosSB} />
        <img src={llSportsLogosBB} />
        <img src={llSportsLogosCH} />
      </div>
    </Col>
  </Row>
)

const LittleLeagueNotice = () => (
  <Grid>
    <Row {...style.notice}>
      <Col xs={12} lg={8} lgPush={2}>
        <p>
          <img src={llLogo} />
        </p>
        <p>
          This store is a Little League® approved gear shop and fundraising
          solution.
        </p>
        <p>
          Little League® Baseball, Little League, the medallion and the keystone
          are the registerd trademarks and service marks belonging exclusivley
          to Little Leage Baseball, Incorporated.
          <br />
        </p>
        <p>
          Visit Little League® at{' '}
          <a href="https://www.littleleague.org">www.littleleague.org</a>
        </p>
      </Col>
    </Row>
  </Grid>
)

export default LittleLeagueNotice
